import React from 'react';
import { FormControl, FormControlLabel, Switch } from '@mui/material';
import { trakrefBlue } from '../../../color_utils';
import PropTypes from 'prop-types';

const OnOffSwitch = ({
    id,
    value,
    label,
    onChange,
    required,
    labelPlacement,
    disabled,
}) => (
    <FormControl
        component="fieldset"
        required={required}
        disabled={disabled}
        sx={{ '&.MuiFormControl-root': { width: '100%' } }}
    >
        <FormControlLabel
            value={value}
            control={
                <Switch
                    id={id}
                    color="primary"
                    onChange={onChange}
                    checked={value}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: trakrefBlue
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: trakrefBlue
                        },
                    }}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
            sx={{
                '&.MuiFormControlLabel-root': {
                    display: 'flex',
                    justifyContent: 'space-between'
                }
            }}
        />
    </FormControl>
);

OnOffSwitch.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    labelPlacement: PropTypes.string,
    disabled: PropTypes.bool,
};

OnOffSwitch.defaultProps = {
    id: "",
    label: "",
    required: false,
    labelPlacement: "start",
    disabled: false,
};

export default OnOffSwitch;
